import get from 'lodash.get';

import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectUpgradeSubscription = createDeepEqualSelector(selectAuth, (auth) => auth.upgradeSubscription);

export const selectIsLoading = createDeepEqualSelector(selectUpgradeSubscription, (upgradeSubscription) =>
  get(upgradeSubscription, 'loading', false),
);

export const selectSuccess = createDeepEqualSelector(selectUpgradeSubscription, (upgradeSubscription) =>
  get(upgradeSubscription, 'success', false),
);

export const selectError = createDeepEqualSelector(selectUpgradeSubscription, (upgradeSubscription) =>
  get(upgradeSubscription, 'err', false),
);

export const selectErrorMessage = createDeepEqualSelector(selectUpgradeSubscription, (upgradeSubscription) =>
  get(upgradeSubscription, 'errMsg', 'Error'),
);
